import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormButton from '../../../../library/form/components/FormActionButton2';

const UpdateActions = (props)=>{
    const { formObject } = props;

    return (
        <>
            <div style={{padding:"5px", margin:"5px"}} className='uiFlexBox uiUpdateActionsList'>
                <FormButton formObject={formObject} rowKey=""
                    action={{ actionId: "refresh",  actionMessage:"Synchronising Table Changes", actionParam: {actionType : "synchTable"}, containerKey: "" }}
                    className="uiActionButton uiSpacerH5" text={<SarasTrans value="Step 1: Synch Table Changes" />}></FormButton>
                <FormButton formObject={formObject} rowKey=""
                    action={{ actionId: "refresh",  actionMessage:"Correcting Characterset", actionParam: {actionType : "synchCharacterSet"}, containerKey: "" }}
                    className="uiActionButton uiSpacerH5" text={<SarasTrans value="Step 2: Correct Table Characterset" />}></FormButton>
                <FormButton formObject={formObject} rowKey=""
                    action={{ actionId: "refresh",  actionMessage:"Synchronising Function Scripts", actionParam: {actionType : "synchScripts"}, containerKey: "" }}
                    className="uiActionButton uiSpacerH5" text={<SarasTrans value="Step 3: Synch View/Sproc/Function/Index Scripts" />}></FormButton>
                <FormButton formObject={formObject} rowKey=""
                    action={{ actionId: "refresh",  actionMessage:"Synchronising Data Scripts", actionParam: {actionType : "synchData"}, containerKey: "" }}
                    className="uiActionButton uiSpacerH5" text={<SarasTrans value="Step 4: Synch Data Scripts" />}></FormButton>
                <FormButton formObject={formObject} rowKey=""
                    action={{ actionId: "refresh",  actionMessage:"Synchronising Configuration", actionParam: {actionType : "synchConfig"}, containerKey: "" }}
                    className="uiActionButton uiSpacerH5" text={<SarasTrans value="Step 5: Synch Configuration" />}></FormButton>
                <FormButton formObject={formObject} rowKey=""
                    action={{ actionId: "refresh",  actionMessage:"Clear Connection Pool", actionParam: {actionType : "clearDBPool"}, containerKey: "" }}
                    className="uiActionButtonBlue uiSpacerH5 ui" text={<SarasTrans value="Clear DB Pool" />}></FormButton>
            </div>
            <div style={{padding:"5px", margin:"5px"}}>
                <h1 style={{fontSize:"15px"}}>If SarasX Software is not working / Frozen / Stuck / Not responding</h1>

                <ul>
                    <li><strong>Option 1</strong>: Click Button "Clear DB Pool"</li>
                    <li><strong>Option 2</strong>: Restart IIS Service (Only if option 1 do not solve the problem)</li>
                    <li><strong>Option 3</strong>: Restart Database Service (Only if option 2 do not solve the problem)</li>
                </ul>

                <div style={{fontWeight:'bold',marginTop:'15px'}}><p>Execute option 1 as first choice, if option 1 solves the problem then do not execute other options</p></div>
            </div>
        </>
    )
}

export default withView(UpdateActions, "updateDB", "", 1);
